export default __webpack_public_path__ + "static/sfds-8524fa497b0a369b10fabce45fd79756.jpg";